import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../styles/core/theme';
import { tokens } from '../styles/core/tokens';
import { useTableDataState } from '../../features/items/state/table-data.state';

export const LoadingIndicator = () => {
   const isLoading = useTableDataState((state) => state.isLoading);
   return (
      <StyledWrapperDiv>
         {isLoading && (
            <StyledOuterDiv className="lds-ellipsis">
               <div />
               <div />
               <div />
               <div />
            </StyledOuterDiv>
         )}
      </StyledWrapperDiv>
   );
};

const StyledOuterDiv = styled.div`
   display: inline-block;
   position: relative;
   width: 80px;
   height: 80px;
   transform: scale(0.6);

   div {
      position: absolute;
      top: 33px;
      width: 13px;
      height: 13px;
      border-radius: 50%;
      background: ${theme.colors.bg.tertiary};
      animation-timing-function: cubic-bezier(0, 1, 1, 0);
   }

   div:nth-of-type(1) {
      left: 8px;
    animation: lds-ellipsis1 ${tokens.animation.duration.ellipsis} infinite;
   }

   div:nth-of-type(2) {
      left: 8px;
      animation: lds-ellipsis2 0.6s infinite;
   }

   div:nth-of-type(3) {
      left: 32px;
      animation: lds-ellipsis2 0.6s infinite;
   }

   div:nth-of-type(4) {
      left: 56px;
      animation: lds-ellipsis3 0.6s infinite;
   }

   @keyframes lds-ellipsis1 {
      0% {
         transform: scale(0);
      }
      100% {
         transform: scale(1);
      }
   }
   @keyframes lds-ellipsis3 {
      0% {
         transform: scale(1);
      }
      100% {
         transform: scale(0);
      }
   }
   @keyframes lds-ellipsis2 {
      0% {
         transform: translate(0, 0);
      }
      100% {
         transform: translate(24px, 0);
      }
   }
`;

const StyledWrapperDiv = styled.div`
   position: absolute;
   top: ${tokens.space.md};
   left: 27rem;
`;
